import { Checkbox, type CheckboxProps, Spin } from "antd"
import React, { useState } from "react"

export function ProjectViewChecklistsListCheckbox({
  onChange,
  disabled,
  ...props
}: CheckboxProps) {
  const [saving, setSaving] = useState(false)

  const onChangeHandler: CheckboxProps["onChange"] = async (e) => {
    try {
      setSaving(true)
      await onChange?.(e)
    } finally {
      setSaving(false)
    }
  }

  return (
    <Spin spinning={saving} size="small">
      <Checkbox
        disabled={saving || disabled}
        onChange={onChangeHandler}
        {...props}
      />
    </Spin>
  )
}
